import { customSelectInstances } from './customSelect';

const teamFilterSelectCustomSelectInstance = customSelectInstances
  .find((instance) => instance.select.id === 'team-filter-select');

jQuery(($) => {
  if (!$('body').hasClass('page-template-team_archive')) {
    return;
  }

  let selectedDivision = '';
  let searchQuery = '';
  let selectedSectionTitle = '';

  function doFilter() {
    const hasDivisionFilter = selectedDivision.length > 0;
    const hasSearchFilter = searchQuery.length > 0;
    const hasSectionFilter = selectedSectionTitle.length > 0;

    // If no filters are active, show everything
    if (!hasDivisionFilter && !hasSearchFilter && !hasSectionFilter) {
      $('.team__member').show();
      $('section.team').show();
      return;
    }

    $('section.team').each(function processSection() {
      const $section = $(this);
      const sectionTitle = $section.find('.team__title').text().trim();
      const sectionTitleLower = sectionTitle.toLowerCase();
      const sectionIsSelectedSection = hasSectionFilter && (sectionTitle === selectedSectionTitle);
      let sectionHasVisibleMembers = false;

      // Check if search query matches the section title (if so, all members in section are visible)
      const searchMatchesSectionTitle = hasSearchFilter && sectionTitleLower.includes(searchQuery);

      // Process each team member in this section
      $section.find('.team__member').each(function processMember() {
        const $member = $(this);
        const memberDivisions = $member.data('divisions') || [];
        const memberName = $member.find('.team__member-name').text().trim().toLowerCase();
        const memberJobTitle = $member.find('.team__member-title').text().trim().toLowerCase();
        const passesDivisionFilter = hasDivisionFilter
          && memberDivisions.includes(selectedDivision)
          && (!hasSectionFilter || sectionIsSelectedSection);

        // Check search filter
        let passesSearchFilter = searchMatchesSectionTitle;
        if (hasSearchFilter && !searchMatchesSectionTitle) {
          const nameOrTitleMatches = [memberName, memberJobTitle]
            .some((str) => str.includes(searchQuery));
          const divisionMatch = memberDivisions && memberDivisions.some(
            (division) => division.toLowerCase().includes(searchQuery),
          );
          passesSearchFilter = nameOrTitleMatches || divisionMatch;
        }

        // show the member if it passes the search or division filter
        // OR if there is only a section filter and the member belongs to the selected section
        // AND passes the division filter if there is one
        if (
          (passesDivisionFilter || passesSearchFilter)
          || (sectionIsSelectedSection && !hasDivisionFilter)
        ) {
          $member.show();
          sectionHasVisibleMembers = true;
        } else {
          $member.hide();
        }
      });

      if (sectionHasVisibleMembers || sectionIsSelectedSection) {
        $section.show();
      } else {
        $section.hide();
      }
    });
  }

  $('button.division-filter').on('click', function handleDivisionFilter() {
    const isCurrentlyActive = this.classList.contains('active');

    $('button.division-filter').removeClass('active');

    if (!isCurrentlyActive) {
      this.classList.add('active');
      selectedDivision = this.dataset.division;
    } else {
      selectedDivision = '';
    }

    doFilter();
  });

  if (teamFilterSelectCustomSelectInstance) {
    teamFilterSelectCustomSelectInstance.select.addEventListener('change', (e) => {
      selectedSectionTitle = e.target.value.trim();
      doFilter();
    });
  }

  $('#team-filter-search').on('input', function handleSearchInput() {
    searchQuery = $(this).val().toLowerCase();
    doFilter();
  });
});
